import React,{useState} from 'react';
import moment from 'moment';
import { message, Modal} from 'antd';
import { ToothSample, User } from '../../../models';
import { SchoolPerson} from '../components/SchoolPerson';
import { loginInfo } from '../../../config';
import { isStudentCodeExist } from '../../../api/Api';
import { buildSampleResult } from '../../../common';
interface PropsType {
  visible: boolean;
  add: Function;
  setInvisible: Function;
  editRecord:ToothSample;
}

export const SchoolPersonAdd: React.FC<PropsType> = ({ visible, add, setInvisible, editRecord }) => {
  const [age,setAge] = useState(5);
  const handlerOk = async () => {
    if(await isStudentCodeExist(editRecord.classId,editRecord.code)){
      message.warning("学生代码已经存在,请修改再保存.");
      return;
    };
    let sample: ToothSample = {
      ...editRecord,
    };
    sample.initId = loginInfo.user.id;
    sample.initName = loginInfo.user.userName;
    sample.initDate = moment().format("YYYY-MM-DD HH:mm:ss");
    sample.status = "初始化";
    sample.type = 0;
    if(sample.cat >= 0){
      sample.status = "检测";
      buildSampleResult(sample);
    }
    add(sample);
    setInvisible();
  }

  const handlerCancel = () => {
    setInvisible();
  }

  return (
    <>
      <Modal
        title="添加校园检测受检人信息"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText='保存'
        cancelText='取消'        
      >
        <SchoolPerson setAge={setAge} editRecord={editRecord} />
      </Modal>

    </>
  )
};